import { render, staticRenderFns } from "./InputRadioGroup.vue?vue&type=template&id=bbe9eaa8&scoped=true&"
import script from "./InputRadioGroup.vue?vue&type=script&lang=js&"
export * from "./InputRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./InputRadioGroup.vue?vue&type=style&index=0&id=bbe9eaa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe9eaa8",
  null
  
)

export default component.exports